import format from 'utils/dateFns/format'
import { subWeeks } from 'date-fns'
import { Icon } from 'gu-ui-kit'
import React from 'react'

const now = new Date()
const startDate = subWeeks(now, 2)

export default (network) => {
  const common = {
    initial: {
      query: '',
      date_group_period: 'day',
      date_from: format(startDate, 'yyyy-MM-dd'),
      date_to: format(now, 'yyyy-MM-dd'),
      include_vat: true,
    },
    configuration: {
      query: {
        subbutton: { isVisible: (value = '') => !!value },
        label: 'statistics::filters.dropdown.items.query.label',
        placeholder: 'statistics::filters.input.placeholder',
        order: 1,
        type: 'input',
      },
      date_group_period: {
        options: ['day', 'week', 'month'],
        subbutton: {
          clearIgnore: true,
        },
      },
      datepicker: {
        names: ['date_from', 'date_to'],
        subbutton: {
          // eslint-disable-next-line no-unused-vars
          isVisible: (value = [], breakpoints) => !!breakpoints.sm,
        },
        // @todo нужен общий лейбл а не в пульсе
        label: 'pulse::filters.range.label',
        order: 2,
        type: 'datepicker',
      },
      include_vat: {
        order: 2,
        type: 'switcher',
        label: 'statistics::filters.include_vat.label',
        optionLabelPrefix: 'pulse::filters.include_vat.',
        subbutton: {
          // eslint-disable-next-line no-unused-vars
          isVisible: (value = [], breakpoints) => !!breakpoints.mds,
          clearIgnore: true,
        },
        options: [true, false],
      },
    },
  }

  switch (network) {
    case 'vk':
      common.initial.status = ''
      common.configuration.status = {
        subbutton: {
          isVisible: (value = [], breakpoints) =>
            value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-34'}
            color={'basic-primary-white'}
          />
        ),
        label: 'statistics::filters.dropdown.items.campaign_status.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix:
          'statistics::filters.dropdown.items.ads_status.options.',
        options: ['active', 'archived', 'paused'],
      }

      return common

    case 'yandexdirect':
      common.initial.state = ''
      common.configuration.state = {
        subbutton: {
          isVisible: (value = [], breakpoints) =>
            value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-34'}
            color={'basic-primary-white'}
          />
        ),
        label: 'statistics::filters.dropdown.items.ads_state.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix:
          'statistics::filters.dropdown.items.ads_state.options.',
        options: ['archived', 'suspended', 'off_by_monitoring', 'on', 'off'],
      }

      return common
    case 'googleads':
      common.initial.status = ''
      common.configuration.status = {
        subbutton: {
          isVisible: (value = [], breakpoints) =>
            value.length > 0 || !!breakpoints.fb,
        },
        icon: (
          <Icon
            name={'checkmark2'}
            size={'s'}
            bgColor={'secondary-34'}
            color={'basic-primary-white'}
          />
        ),
        label: 'statistics::filters.dropdown.items.ads_status.label',
        position: 'dropdown',
        type: 'radio group',
        optionLabelPrefix:
          'statistics::filters.dropdown.items.ads_status.options.',
        options: ['enabled', 'paused', 'removed'],
      }

      return common
  }
}
